export const CheckString = (value) => {
    if (typeof value === "string")
        return true
    else return false
}